import { Form } from 'react-final-form'
import { FormCheckbox, FormInput } from '../../forms/final-form-fields'
import { defineMessages, FormattedMessage } from 'react-intl'
import { createUrl } from 'localized-urls'
import { messages as profileMessages } from '../../checkout-adventures/user-forms/ProfileInfo'
import { toast } from 'react-toastify'
import API from 'api'
import { Fragment } from 'react'
import { createAccountValidation } from '../validation'

const messages = defineMessages({
  toSubscribe: {
    id: 'toSubsribe',
    defaultMessage: `I'd like to receive inspiring emails from PADI featuring incredible dive destinations, PADI courses, products, event invitations and amazing marine life.`,
  },
})

export default function CreateAccountForm({
  email,
  orderId,
  firstName,
  lastName,
  setAccountCreated,
}) {
  const createAccount = (values) => {
    API('account/register/')
      .post({
        ...values,
        password2: values.password,
        orderId,
        firstName,
        lastName,
      })
      .then(() => {
        toast.success(
          <FormattedMessage
            id='account_created'
            defaultMessage='Your account was successfully created.'
          />
        )
        setAccountCreated(true)
      })
  }
  return (
    <Form
      onSubmit={createAccount}
      subscription={{
        value: true,
      }}
      initialValues={{
        email,
      }}
      validate={createAccountValidation}
      render={({ handleSubmit }) => (
        <Fragment>
          <FormattedMessage
            id='next_step'
            defaultMessage='Next step'
            tagName='h3'
          />
          <form onSubmit={handleSubmit}>
            <FormInput
              name='email'
              label={profileMessages.email}
              isRequired
              disabled
            />
            <FormInput
              type='password'
              name='password'
              label={profileMessages.password}
              isRequired
            />
            <FormCheckbox
              name='isTermsAccepted'
              label={
                <FormattedMessage
                  id='padi_terms_accept'
                  defaultMessage='I accept PADI Travel <a>Terms and conditions</a>'
                  values={{
                    a: (chunks) => (
                      <a href={createUrl('terms')} target='_blank'>
                        {chunks}
                      </a>
                    ),
                  }}
                />
              }
            />
            <FormCheckbox name='toSubscribe' label={messages.toSubscribe} />

            <button className='btn-red-invert small-margin'>
              <FormattedMessage
                id='create_my_acc'
                defaultMessage='Create my account'
              />
            </button>
          </form>
        </Fragment>
      )}
    />
  )
}
